import { useMemo } from 'react'

import { CHANGELOG } from '../changelog/changelog.ts'

function toMs(iso: string): number {
  const ms = Date.parse(iso)
  return Number.isFinite(ms) ? ms : 0
}

export function useStaticChangelog() {

  const entries = CHANGELOG

  const newestPublishedAtMs = useMemo(() => {
    const newest = entries[0]
    return newest ? toMs(newest.publishedAt) : 0
  }, [entries])

  return { entries, newestPublishedAtMs }
}
